enum Currency {
  Australia = 'AUD',
}

export default Currency;
